import { Box, Button } from "@mui/material";
import { Dialog, DialogContent } from '@mui/material';
import { useState } from 'react';
import { useLocation } from "react-router-dom";
import PrintIcon from '@mui/icons-material/Print';


const ViewContentStructure = () => {
    const location = useLocation();
    const { data } = location.state || {};
    const { title, contentStructure } = data || {};

    const [selectedImage, setSelectedImage] = useState("");
    const [open, setOpen] = useState(false);

    console.log("📄 View Content Structure:", data);

    const handlePrint = () => {
        window.print();
    };

    const handleImageClick = (url: string) => {
        setSelectedImage(url);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedImage("");
    };

    return (
        <Box style={{ padding: "40px" }}>
            <Box sx={{ fontSize: "24px", fontWeight: "bold", marginBottom: "20px" }}>{title || "No Title"}</Box>


            {contentStructure?.map((section: any, index: number) => (
                <Box key={index} style={{ marginBottom: "40px" }}>
                    <Box sx={{ fontSize: "20px", fontWeight: "bold" }}>{section.title || "Untitled Section"}</Box>

                    {section.files?.map((file: any, idx: number) => {
                        const fileUrl = file?.fileUrl || file?.url;
                        const fileName = file?.name || "Unnamed File";
                        const fileType = file?.type?.toLowerCase();


                        if (!fileUrl || !fileType) return null;

                        const isImage = /\.(jpg|jpeg|png)$/i.test(fileUrl);
                        const isPDF = /\.pdf$/i.test(fileUrl);

                        // console.log("📄 File URL:", fileUrl);

                        return (
                            <Box key={idx} style={{ marginTop: "10px" }}>
                                {fileType === "image" && (
                                    <img
                                        src={fileUrl}
                                        alt={fileName}
                                        width="600"
                                        style={{
                                            border: "1px solid #ddd", borderRadius: "6px",
                                            objectFit: "cover",
                                        }}
                                        onClick={() => handleImageClick(fileUrl)}

                                        onError={(e) => {
                                            (e.target as HTMLImageElement).style.display = "none";
                                            console.warn("❌ Image failed to load:", fileUrl);
                                        }}
                                    />
                                )}

                                {fileType === "pdf" && (
                                    <iframe
                                        src={fileUrl}
                                        title={`pdf-${idx}`}
                                        width="600"
                                        height="500px"
                                        style={{ border: "1px solid #ccc", borderRadius: "6px" }}
                                        onError={(e) => {
                                            console.warn("❌ PDF failed to load:", fileUrl);
                                        }}
                                    />
                                )}

                                {fileType !== "image" && fileType !== "pdf" && (
                                    <div style={{
                                        border: "1px solid #ccc", borderRadius: "6px", padding: "10px",
                                        width: "40%", height: "400px", overflow: "hidden"
                                    }}>

                                        <img src={fileUrl ? fileUrl : ""} alt="" width="100%" />
                                        {/* <iframe src={fileUrl ? fileUrl : ""} title={`file-${idx}`} /> */}
                                    </div>

                                )}


                                {/* <p style={{ fontStyle: "italic", marginTop: "4px" }}>{fileName}</p> */}
                            </Box>
                        );
                    })}

                </Box>
            ))}
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="contained" sx={{
                    marginBottom: "20px", color: "#fff", width: "150px", height: "50px",
                    fontSize: "20px", fontWeight: "bold", borderRadius: "6px",
                    backgroundColor: "#1976d2", '&:hover': { backgroundColor: "#115293" }
                }} startIcon={<PrintIcon fontSize="medium" />} onClick={handlePrint}>
                    Print
                </Button>
            </Box>

            {/* Image Full-Size Dialog */}
            <Dialog open={open} onClose={handleClose} maxWidth="xl">
                <DialogContent sx={{ padding: 0 }}>
                    <img src={selectedImage} alt="Full Size" style={{ width: "100%", height: "auto" }} />
                </DialogContent>
            </Dialog>

        </Box>
    );
};

export default ViewContentStructure;
